import { render, staticRenderFns } from "./DrieLuik.vue?vue&type=template&id=434f1c26&scoped=true"
import script from "./DrieLuik.vue?vue&type=script&lang=js"
export * from "./DrieLuik.vue?vue&type=script&lang=js"
import style0 from "./DrieLuik.vue?vue&type=style&index=0&id=434f1c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434f1c26",
  null
  
)

export default component.exports